import { render, staticRenderFns } from "./copy-text.vue?vue&type=template&id=78bd3c9c&scoped=true"
import script from "./copy-text.vue?vue&type=script&lang=js"
export * from "./copy-text.vue?vue&type=script&lang=js"
import style0 from "./copy-text.vue?vue&type=style&index=0&id=78bd3c9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd3c9c",
  null
  
)

export default component.exports